import { EmergencyContactData } from "../types/EmergencyContact";
import { patientApiUrl } from "./api";

const API_URL = "/EmergencyContacts";

export const getData = async (id: number): Promise<EmergencyContactData[]> => {
  try {
    const res = await patientApiUrl.get<EmergencyContactData[]>(
      `${API_URL}/emergency-contacts?id=${id}`
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all emergency contacts error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (
  id: number
): Promise<EmergencyContactData | null> => {
  try {
    const res = await patientApiUrl.get<EmergencyContactData>(
      `${API_URL}/${id}`
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get emergency contact error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null; // Return null on error
  }
};

export const createData = async (
  user: Partial<EmergencyContactData>
): Promise<EmergencyContactData | null> => {
  try {
    const res = await patientApiUrl.post<EmergencyContactData>(API_URL, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create emergency contact error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  user: Partial<EmergencyContactData>
): Promise<EmergencyContactData | null> => {
  try {
    const res = await patientApiUrl.put<EmergencyContactData>(
      `${API_URL}/${id}`,
      user
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Update emergency contact error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete emergency contact error: ${
        error.response?.data?.message || error.message
      }`
    );
    return false;
  }
};
